package com.milta.core.localization.translations.nl

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Inloggen",
    logout = "Uitloggen",
    email = "E-mail",
    password = "Wachtwoord",
    showPassword = "Tonen",
    hidePassword = "Verbergen",
    roleSelectionTitle = "Account aanmaken",
    roleSelectionSubtitle = "Kies het accounttype dat bij uw profiel past",
    roleDriverTitle = "Ik ben een chauffeur - koerier",
    roleDriverDescription = "Ik rijd een transport- of bezorgvoertuig en wil mijn ritten optimaliseren",
    roleDriverTag1 = "Mijn ritten optimaliseren",
    roleDriverTag2 = "Milta deals op mijn route",
    roleEnterpriseTitle = "Ik ben een bedrijf",
    roleEnterpriseDescription = "Ik heb een btw-nummer en beheer een wagenpark en een team van chauffeurs",
    roleEnterpriseTag1 = "Vlootbeheer",
    roleEnterpriseTag2 = "Team opvolging",
    continueButton = "Doorgaan",
    registerFormTitle = "Voltooi uw registratie",
    registerFormSubtitle = "Bevestig uw telefoonnummer om uw account te activeren.",
    registerFormSubtitleEnterprise = "Vul uw organisatie en een telefoonnummer in om uw account te activeren.",
    googleAccountConnected = "Google-account verbonden",
    appleAccountConnected = "Apple-account verbonden",
    firstName = "Voornaam",
    lastName = "Achternaam",
    phoneNumber = "Telefoonnummer",
    phoneNumberHelper = "Voer het telefoonnummer van uw keuze in.",
    phoneNumberOtpInfo = "Er wordt een verificatiecode per sms verzonden om dit nummer te bevestigen.",
    registerButton = "Ontvang een verificatiecode",
    passwordHint = "Minimaal 8 tekens",
    registerSuccess = "Account succesvol aangemaakt",
    errorEmailConflict = "Dit e-mailadres is al in gebruik",
    errorPhoneConflict = "Dit telefoonnummer is al geregistreerd",
    errorPhoneChangeCooldown = "U kunt uw telefoonnummer maar één keer per 30 dagen wijzigen",
    errorGeneric = "Verbinding mislukt. Controleer je netwerk en probeer opnieuw.",
    errorFirstNameRequired = "Voer uw voornaam in",
    errorFirstNameTooLong = "Voornaam mag niet langer zijn dan 100 tekens",
    errorLastNameRequired = "Voer uw achternaam in",
    errorLastNameTooLong = "Achternaam mag niet langer zijn dan 100 tekens",
    errorPhoneTooLong = "Telefoonnummer mag niet langer zijn dan 20 tekens",
    errorOAuthAccountExists = "Dit account is al gekoppeld aan een ander Milta-account. Probeer in te loggen.",
    errorOAuthTokenInvalid = "Uw sessie is verlopen. Probeer opnieuw in te loggen.",
    loginTitle = "Inloggen",
    loginTabPassword = "Wachtwoord",
    loginTabPhone = "Telefoon",
    loginButton = "Inloggen",
    forgotPassword = "Wachtwoord vergeten?",
    sendCodeButton = "Code versturen",
    otpTitle = "Voer de code in",
    otpSubtitle = "We stuurden een 6-cijferige code naar",
    otpVerifyButton = "Verifiëren",
    otpResend = "Code opnieuw versturen",
    otpResendPrefix = "Geen code ontvangen?",
    otpWrongNumber = "Verkeerd nummer?",
    otpModifyLink = "Wijzigen",
    forgotPasswordTitle = "Wachtwoord vergeten",
    forgotPasswordSubtitle = "Voer uw e-mail in om een resetlink te ontvangen",
    forgotPasswordButton = "Link versturen",
    forgotPasswordSuccess = "Controleer uw inbox",
    resetPasswordTitle = "Nieuw wachtwoord",
    resetPasswordSubtitle = "Kies een nieuw wachtwoord voor uw account",
    resetPasswordNewLabel = "Nieuw wachtwoord",
    resetPasswordConfirmLabel = "Bevestig wachtwoord",
    resetPasswordButton = "Wachtwoord opnieuw instellen",
    resetPasswordSuccess = "Wachtwoord opnieuw ingesteld. U kunt nu inloggen.",
    errorPasswordTooShort = "Wachtwoord moet minimaal 8 tekens bevatten",
    errorPasswordTooLong = "Wachtwoord mag niet langer zijn dan 128 tekens",
    errorPasswordMismatch = "Wachtwoorden komen niet overeen",
    errorTokenInvalid = "Deze resetlink is ongeldig of verlopen. Vraag een nieuwe aan.",
    errorEmailInvalid = "Voer een geldig e-mailadres in",
    errorPhoneRequired = "Voer een telefoonnummer in",
    errorInvalidCredentials = "Verkeerd e-mailadres of wachtwoord. Gebruik 'Wachtwoord vergeten?' indien nodig.",
    errorInvalidOtp = "Onjuiste code. Controleer je SMS of vraag een nieuwe aan.",
    errorExpiredOtp = "Code verlopen. Vraag een nieuwe aan.",
    errorTooManyAttempts = "Te veel mislukte pogingen. Probeer over een paar minuten opnieuw.",
    errorResendLimit = "Te veel herverzendverzoeken. Probeer over een paar minuten opnieuw.",
    otpResendIn = "Opnieuw verzenden over %d s",
    otpAttemptsLeft = "Nog %d pogingen over",
    loginGreeting = "Welkom terug!",
    loginSubtitle = "Meld u aan bij uw Milta-account",
    loginSmsOption = "Een sms-code ontvangen",
    noAccount = "Nog geen account?",
    signUp = "Registreren",
    organizationName = "Naam van de organisatie",
    organizationNameRequired = "Voer de naam van de organisatie in",
    registerNextButton = "Volgende",
    passwordConfirm = "Wachtwoord bevestigen",
    passwordRuleUpper = "Eén hoofdletter",
    passwordRuleDigit = "Één cijfer",
    passwordRuleSpecial = "Één speciaal teken",
    alreadyHaveAccount = "Al een account — Inloggen",
)
